import { Grid } from '@mui/material';
import { IssueDecisionTimeReportResult } from '@tap/data-providers';
import { PeriodSelectType, PeriodSelectTypeSpec, Widget } from '@tap/mui-ui';
import { ChartCustom, CustomChartTooltip } from '@tap/tap-ui';
import { dateTimeHelper } from '@tap/utils';
import {
    XAxis, YAxis, CartesianGrid,
    Tooltip as RechartsTooltip, Bar, BarChart,
} from 'recharts';

/* График Время на решение заявок
*/

const getMaxValue = (initialData: IssueDecisionTimeReportResult[]) => {
    const timeQuantityAvgList = initialData?.map(item => item.timeQuantityAvg);
    return Math.max(...timeQuantityAvgList) || 1;
};

type IssueDecisionTimeChartProps = {
    reportData: IssueDecisionTimeReportResult[],
    periodType: PeriodSelectType,
}


export default function IssueDecisionTimeChart({ reportData, periodType }: IssueDecisionTimeChartProps) {

    const maxValue = getMaxValue(reportData);

    return (
        <Widget title={`График показывает сколько часов в среднем прошло с момента создания заявок до их завершения за последние ${PeriodSelectTypeSpec[periodType].daysQuantity} дней`}>
            <ChartCustom>
                <BarChart data={reportData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                        type="category"
                        dataKey="endDate"
                        scale={'auto'}
                        tick={{ dy: 5, fontSize: '12px' }}
                        tickFormatter={(date: any) => dateTimeHelper.format(date, 'd MMM', true) || date}
                    />
                    <YAxis
                        dataKey='timeQuantityAvg'
                        domain={[0, maxValue]}
                        tick={{ fontSize: '12px' }}
                    />
                    <RechartsTooltip
                        wrapperStyle={{ outline: 'none' }}
                        content={
                            <CustomChartTooltip
                                labelTemplate={(label) => {
                                    return dateTimeHelper.format(label, 'd MMMM yyyy');
                                }}
                                valueTemplate={payload => (
                                    <>
                                        <Grid sx={{ color: 'black' }}>Завершённые заявки: {payload.payload.completedIssueCount}</Grid>
                                        <Grid>{payload.name}: {payload.value}</Grid>
                                    </>
                                )}
                            />
                        }
                    />
                    <Bar
                        opacity={.8}
                        name={'Среднее время на решение по заявке, ч.'}
                        dataKey="timeQuantityAvg"
                        stroke={'#2196f3'}
                        fill={'#2196f3'}
                    />
                </BarChart>
            </ChartCustom>
        </Widget>
    );
}

